import { ThemeTonalRange } from '@philips-emr/tws-constants';
import Controller, { OnMount } from '@philips-emr/tws-core/lib/client';
import { ThemeService } from '@philips-emr/tws-core/lib/services';

import { FragmentNames, InactivityAliases } from '../../codegen';
import { pollingService } from '../../services/polling/polling-service';

@Controller({ fragment: FragmentNames.INACTIVITY })
export default class DashboardController {

  @OnMount(InactivityAliases.LAYOUT_INACTIVITY)
  onMountLayoutInatividade(): void {
    ThemeService.setContentTonalRange(ThemeTonalRange.ULTRA_LIGHT);
    pollingService.removePolling('mensagem');
    pollingService.removePolling('notificacao');
  }
}
